import React, { useState, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { customerService } from '../services/CustomerService';

const CustomerAutoComplete = ({ value, onChange, placeholder = "Müşteri Ara...", className = "" }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    useEffect(() => {
        if (value && typeof value === 'number') {
            customerService.getById(value).then(res => {
                if (res.data.success) {
                    setSelectedCustomer(res.data.data);
                }
            });
        } else if (!value) {
            setSelectedCustomer(null);
        }
    }, [value]);

    const search = async (event) => {
        try {
            const res = await customerService.autoCompleteSearch(event.query);
            setSuggestions(res.data);
        } catch (error) {
            console.error("Müşteri arama hatası:", error);
        }
    };

    const onSelect = (e) => {
        setSelectedCustomer(e.value);
        onChange(e.value.id);
    };

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-column">
                <span className="font-bold">{item.name}</span>
                <small className="text-gray-500">{item.phone}</small>
            </div>
        );
    };

    return (
        <AutoComplete
            value={selectedCustomer}
            suggestions={suggestions}
            completeMethod={search}
            field="name"
            placeholder={placeholder}
            itemTemplate={itemTemplate}
            onChange={(e) => {
                if (e.value === '') {
                    setSelectedCustomer(null);
                    onChange(null);
                } else {
                    setSelectedCustomer(e.value);
                }
            }}
            onSelect={onSelect}
            className={className}
            dropdown
        />
    );
};

export default CustomerAutoComplete;
